import type { HgClubInfo } from '@ps/web-shared-api-types/v0/SwHomeGames';
import { Link, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { forwardRef } from 'react';

import Button from '@swf/components/StarsButton/StarsButton';
import { ClubMemberAvatars, Image, PKR_ROLE_TRANSLATIONS, useCancelJoinClub } from '@swf/poker';

import { ClubRoute, UserClubRole } from '../../../types/common';
import ClockIcon from '../assets/clock-icon.svg';

import { TXTCLI_Cancel } from './ClubItem.messages.json';
import styles from './ClubItem.scss';

type Props = HgClubInfo & {
  ref: React.Ref<HTMLDivElement>;
};

const ClubItem: React.FC<Props> = forwardRef(
  ({ clubImage, clubId, clubName, roleForUser }, ref) => {
    const isConfirmation = roleForUser === UserClubRole.Confirmation;
    const disableLink = isConfirmation || roleForUser === UserClubRole.Suspended;
    const { handleCancel, loading } = useCancelJoinClub(clubId as number);

    return (
      <Link
        alias="homeGamesClubs"
        values={{ clubId, section: ClubRoute.Lobby }}
        className={classNames(styles.outer, {
          [styles.disabled]: disableLink
        })}
      >
        <div
          ref={ref}
          className={classNames(styles.container, {
            [styles.faded]: isConfirmation || roleForUser === UserClubRole.Suspended
          })}
        >
          <div className={styles.avatarContainer}>
            <div className={styles.avatar}>
              <Image imageByteArray={clubImage} />
            </div>
            {isConfirmation && <ClockIcon className={styles.clockIcon} />}
          </div>
          <div className={styles.name}>{clubName}</div>
          <div className={styles.role}>
            {typeof roleForUser !== 'undefined' && (
              <Translation {...PKR_ROLE_TRANSLATIONS[roleForUser]} />
            )}
          </div>
          {isConfirmation ? (
            <Button
              className={styles.cancel}
              variant="secondary"
              translation={TXTCLI_Cancel}
              onClick={handleCancel}
              disabled={loading}
            />
          ) : (
            clubId && <ClubMemberAvatars clubId={clubId} className={styles.memberAvatars} />
          )}
        </div>
      </Link>
    );
  }
);

export default ClubItem;
